<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>
<app-header></app-header>
<app-botao-chat></app-botao-chat>
<app-alert-generico
  [message]="modalRecalculo.message"
  [type]="modalRecalculo.type"
  [buttons]="modalRecalculo.buttons"
  [show]="necessitaRecalculo && showModalRecalculo"
[description]="modalRecalculo.description"></app-alert-generico>

<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>

        <div class="titulo-header mb-4">
          <div class="titulo-info">
            <h1 class="titulo mb-1">Fazer pedido</h1>
            <p class="mb-0">Tipo de pedido:
              <b>{{ statusRC === 'true' ? 'com economia' : 'complementar (sem economia)' }}</b>
            </p>

            @if (!erro) {
              <div class="filtros-panel mt-4">
                <div class="filtros-section">
                  <div class="mb-0">
                    <label class="texto-titulo" for="slctFiltroStatusCalculo">FILTRO PARA STATUS DO CÁLCULO</label>
                    <app-select
                      [value]="filtro"
                      (valueChanges)="filtro = $event"
                      name="filtroName"
                      id="slctFiltroStatusCalculo"
                      [options]="[
                        {name : 'TODOS' , value : ''} ,
                        {name : 'PROCESSADOS' , value : 'PROCESSADO'} ,
                        {name : 'PROCESSANDO' , value : 'PROCESSANDO'} ,
                        {name : 'ERRO' , value : 'ERRO'},
                        {name : 'SEM CÁLCULOS' , value : 'SEM CALCULO'}
                      ]"
                      optionValue="value"
                      optionText="name"
                      [tag]="addTagManagerInteraction('select:dropdown:click', 'filtro-para-status-do-calculo')"
                    ></app-select>
                  </div>
                  <div class="mb-0">
                    <label class="texto-titulo" for="inptFiltroCnpj">FILTRO DE PESQUISA POR CNPJ</label>
                    <input
                      mask="AA.AAA.AAA/AAAA-00"
                      type="text"
                      class="form-control"
                      id="inptFiltroCnpj"
                      [(ngModel)]="cnpjFilter"
                      (input)="companyFilter()"
                      placeholder="Digite um CNPJ"
                      [tag]="addTagManagerInteraction('box:cnpj-field:filled', 'filtro-de-pesquisa-por-cnpj')"
                      >
                  </div>
                  <button
                    type="button"
                    class="botao"
                    id="btnFiltrar"
                    (click)="filtrar()"
                    [tag]="addTagManagerInteraction('box:button:click', 'filtrar')"
                  >FILTRAR</button>
                </div>
              </div>
            }
          </div>

          @if (!erro) {
            <div class="calculos-andamento-card">
              <span class="texto-titulo">CÁLCULOS EM ANDAMENTO</span>
              <ul class="calculos-andamento-lista">
                <li>
                  <span class="calculos-andamento-label">Processados</span>
                  <span class="calculos-andamento-valor" [ngClass]="{'green': countStatusTotalEmProcessamento === 0}">{{ countStatusTotalProcessados }}</span>
                </li>
                <li>
                  <span class="calculos-andamento-label">Processando</span>
                  <span class="calculos-andamento-valor" [ngClass]="{'green': (countStatusTotalEmProcessamento + countStatusTotalInicio) > 0}">{{ (countStatusTotalEmProcessamento + countStatusTotalInicio) }}</span>
                </li>
                <li>
                  <span class="calculos-andamento-label">Erro</span>
                  <span class="calculos-andamento-valor" [ngClass]="{'red': countStatusTotalErro > 0}">{{ countStatusTotalErro }}</span>
                </li>
                <li>
                  <span class="calculos-andamento-label">Sem Cálculos</span>
                  <span class="calculos-andamento-valor">{{ countStatusTotalSemCalculo }}</span>
                </li>
                <li class="calculos-andamento-total">
                  <span class="calculos-andamento-label">Total</span>
                  <span class="calculos-andamento-valor">{{ countStatusTotalEmpresas }}</span>
                </li>
              </ul>
            </div>
          }
        </div>

        @if (!erro) {
          <div class="row">
            <div class="col-12">
              <!-- TABELA -->
              <table class="table table-hover border-bottom mt-2">
                <caption>Tabela com lista de empresas</caption>
                <thead>
                  <tr>
                    <th scope="col">
                      <div class="form-check">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          [(ngModel)]="selectAll"
                          [checked]="allCompaniesSelected"
                          (click)="selectAllCompanies($event)"
                          (keydown.enter)="selectAllCompanies($event)"
                          (keydown.space)="selectAllCompanies($event)"
                          id="selectAllPedidos">
                        <label class="form-check-label" for="selectAllPedidos" aria-label="Selecionar todos os pedidos">
                        </label>
                      </div>
                    </th>
                    <th scope="col"></th>
                    <th scope="col">CNPJ</th>
                    <th scope="col">RAZÃO SOCIAL</th>
                    <th scope="col">STATUS</th>
                    <th scope="col">VALOR A PAGAR</th>
                    @if (flagStatusRC === true) {
                      <th scope="col">RECARGA CERTA</th>
                    }
                    <th scope="col">DATA CÁLCULO</th>
                  </tr>
                </thead>
                <tbody>
                  @for (emp of filteredCompanyList | paginate: { id: 'enderecos', itemsPerPage: itemsPerPage , currentPage: currentPage, totalItems: totalItems} ; track emp; let i = $index) {
                    <tr
                      >
                      <td style="width: 15px;">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            id="checkbox{{ i }}"
                            [checked]="isChecked(emp.idEmpresa)"
                            (click)="onTableAddressClick(emp.idEmpresa, emp.statusCalculo, emp.idPedidoAtivo, emp.flagRecargaCerta); addTagInCheck(emp.flagRecargaCerta, emp.dataCalculo)"
                            (keydown.enter)="onTableAddressClick(emp.idEmpresa, emp.statusCalculo, emp.idPedidoAtivo, emp.flagRecargaCerta); addTagInCheck(emp.flagRecargaCerta, emp.dataCalculo)"
                            (keydown.space)="onTableAddressClick(emp.idEmpresa, emp.statusCalculo, emp.idPedidoAtivo, emp.flagRecargaCerta); addTagInCheck(emp.flagRecargaCerta, emp.dataCalculo)"
                            name="checkPedidos"
                            [attr.aria-label]="'Selecionar empresa ' + emp.idEmpresa">
                          <label class="form-check-label" for="checkbox{{ i }}" aria-label="Selecionar empresa">
                          </label>
                        </div>
                      </td>
                      <td style="width: 15px; padding-left:0px; padding-right: 0px;">
                        @if (emp.flagTeveAtualizacao === false && emp.statusCalculo !== 'ERRO') {
                          <div>
                            <i class="fa fa-exclamation-circle c-warning fa-2x ms-3 icone-menor" data-bs-toggle="tooltip"
                              data-placement="top" title="A empresa não teve alteração de dados nos últimos 15 dias."
                            aria-hidden="true"> </i>
                          </div>
                        }
                        @if (emp.statusCalculo === 'ERRO') {
                          <div>
                            <i class="fa fa-exclamation-circle c-danger fa-2x ms-3 icone-menor" data-bs-toggle="tooltip"
                            data-placement="top" title="{{obterMensagemErroCalculo(emp.descricaoStatusCalculo)}}" aria-hidden="true"> </i>
                          </div>
                        }
                      </td>
                      <td style="width: 160px;">{{ emp.cnpj | cnpj }}</td>
                      <td style="width: 385px;">{{ emp.razaoSocial }}</td>
                      <td>{{ emp.statusCalculo }}</td>
                      <td>{{ emp.valorTotal }}</td>
                      @if (flagStatusRC === true) {
                        <td>
                          @if (emp.flagRecargaCerta === true) {
                            <p>SIM</p>
                          }
                          @if (emp.flagRecargaCerta === false) {
                            <p>NÃO</p>
                          }
                        </td>
                      }
                      <td>{{ emp.dataCalculo }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
          <div class="row mt-4 ">
            <div class="col-3 mb-4">
              <app-select
                ngClass="select-outline"
                [value]="itemsPerPage"
                (valueChanges)="onItemsPerPageChange($event)"
                name="itemsPerPageName"
                [options]="[
                                    {name : 'Exibir 5 Empresas' , value : '5'} ,
                                    {name : 'Exibir 10 Empresas' , value : '10'} ,
                                    {name : 'Exibir 15 Empresas' , value : '15'} ,
                                    {name : 'Exibir 20 Empresas' , value : '20'},
                                    {name : 'Exibir 100 Empresas' , value : '100'}
                                ]"
                optionValue="value"
                optionText="name"
                [tag]="addTagManagerInteraction('select:dropdown:click', 'exibir-por-pagina')"
                >
              </app-select>
            </div>
            <div class="col-6 mb-4 text-center ps-0">
              <pagination-controls class="bg-danger ps-0" id="enderecos" (pageChange)="getPage($event)"
                (pageBoundsCorrection)="pageChanged($event)" directionLinks="true" autoHide="true"
                responsive="true" previousLabel="Anterior" nextLabel="Próximo"
                screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
                screenReaderCurrentLabel="Página"
                [tag]="addTagManagerInteraction('select:number:click', 'escolher-proxima-pagina')">
              </pagination-controls>
            </div>
            @if (totalItemsExiba < 2) {
              <p class="texto-tabela col-3 text-nowrap text-end">
                <span>{{ totalItemsExiba }}</span> Registro foi encontrado</p>
              }
              @if (totalItemsExiba >= 2) {
                <p class="texto-tabela col-3 text-nowrap text-end">
                  <span>{{ totalItemsExiba }}</span> Registros foram encontrados</p>
                }
              </div>
              <div class="text-center">
                <button class="botao" id="refazerCalculoBtn" (click)='refazerCalculo()'
                  [tag]="addTagManagerInteraction('box:button:click', 'refazer-calculo')">Refazer Cálculo
                </button>
                &nbsp;
                <button
                  class="botao"
                  id="btnAvancar"
                  (click)="avancar()"
                  [disabled]="checkedCompanyIds.length > 0 && (!liberaBotaoAvancar || bloqueiaAvancoPorCalculoDesatualizado)"
                  [ngClass]="{'disabled': checkedCompanyIds.length > 0 && (!liberaBotaoAvancar || bloqueiaAvancoPorCalculoDesatualizado)}"
                  [tag]="addTagManagerInteraction('box:button:click', 'avancar')">
                  Avançar
                </button>
                @if (checkedCompanyIds.length > 0 && bloqueiaAvancoPorCalculoDesatualizado) {
                  <div
                    class="alert alert-warning mt-3 mx-auto"
                    style="max-width: 720px;">
                    {{ motivoBloqueioAvancoPorCalculoDesatualizado }}
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <app-footer></app-footer>
